import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class ConfirmDialog extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene,bgName, msg, fontsize = 48) {
    super(scene);

    this.cover = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0x000000, 0.9).setOrigin(0)
      .setInteractive();
    this.add(this.cover);

    this.boxContainer = new Phaser.GameObjects.Container(this.scene);

    this.bg = ABCyaPhaser.Images.addImage(0,0,bgName, this.boxContainer);

    this.lblMsg = ABCyaPhaser.Text.addText(0, -this.bg.height / 2 + 35, fontsize, 0x000000, FontKeys._BPreplay, msg, this.boxContainer, true).setOrigin(0.5, 0)
      .setWordWrapWidth(this.bg.getBounds().width - 20)
      .setLineSpacing(-10);

    this.btnYes = this.scene.add.rectangle(0,0,114, 114, 0x89c540).setOrigin(0)
      .setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickYes());
    this.boxContainer.add(this.btnYes);
    this.btnYes.x = -this.btnYes.width - 10;
    this.btnYes.y = 5;
    const btnYesTxt = ABCyaPhaser.Text.addText(this.btnYes.x + this.btnYes.width / 2,this.btnYes.y + this.btnYes.height / 2 + 5,48, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.yes_button'), this.boxContainer, true);

    this.btnNo = this.scene.add.rectangle(0,0,114, 114, 0xed2224).setOrigin(0)
      .setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickNo());
    this.boxContainer.add(this.btnNo);
    this.btnNo.x = 10;
    this.btnNo.y = 5;
    const btnNoTxt = ABCyaPhaser.Text.addText(this.btnNo.x + this.btnNo.width / 2,this.btnNo.y + this.btnNo.height / 2 + 5,48, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.no_button'), this.boxContainer, true);

    this.boxContainer.x = this.cover.width / 2;
    this.boxContainer.y = this.cover.height / 2;
    this.boxContainer.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.boxContainer, 1200, { scale: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    this.add(this.boxContainer);
  }

  onClickYes () {
    this.emit('YES');
  }

  onClickNo () {
    this.emit('NO');
  }
}